var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define('collections/contact/PropertyCollection',['require','underscore','evertrue','ET/ETCollection','models/contact/PropertyModel'],function(require) {
  var ETCollection, EverTrue, PropertyCollection, PropertyModel, _;
  _ = require("underscore");
  EverTrue = require("evertrue");
  ETCollection = require("ET/ETCollection");
  PropertyModel = require("models/contact/PropertyModel");
  return PropertyCollection = (function(_super) {
    __extends(PropertyCollection, _super);

    function PropertyCollection() {
      return PropertyCollection.__super__.constructor.apply(this, arguments);
    }

    PropertyCollection.prototype.urlRoot = "contacts/v1/properties/";

    PropertyCollection.prototype.model = PropertyModel;

    PropertyCollection.prototype.initialize = function() {
      return this.changed_models = [];
    };

    PropertyCollection.prototype.parse = function(data) {
      this.schema = new Backbone.Model(data);
      return data;
    };

    PropertyCollection.prototype.save = function() {
      var requests;
      requests = [];
      _.each(this.changed_models, function(model) {
        return requests.push(model.save(null, {
          wait: true
        }));
      });
      return $.when.apply(void 0, requests).then((function(_this) {
        return function() {
          return _this.changed_models = [];
        };
      })(this));
    };

    PropertyCollection.prototype.queueSave = function(set) {
      if (_.isArray(set)) {
        return _.each(set, (function(_this) {
          return function(prop) {
            return _this.changed_models.push(prop);
          };
        })(this));
      } else {
        return this.changed_models.push(set);
      }
    };

    return PropertyCollection;

  })(ETCollection);
});

//# sourceMappingURL=PropertyCollection.js.map
;
